<template>
  <div>
    <v-container fluid>
      <v-layout justify-space-between>
        <v-flex xs3 sm3 md3 d-flex>
          <div>
            <measurement-manage-modal :patient-id="patient_id" ref="measurementManageModal"/>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <measurements-table :patient_id="patient_id" @edit-measurement="editMeasurement"/>
    <body-composition-analysis-table :patient_id="patient_id" @edit-measurement="editMeasurement"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: {
    patient_id: {
      type: Number,
    }
  },
  methods: {
    ...mapActions(['setEditedMeasurement']),
    editMeasurement(measurement) {
      measurement.created_at = measurement.created_at.split('.').reverse().join('-');
      this.setEditedMeasurement(measurement);
      this.$refs.measurementManageModal.open();
    },
  }
}
</script>
